export const switchSpinDirection = (currentDirection) => {
  return currentDirection === 'x' ? 'y' : 'x';
};
